import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// The general section of https://www.grs-pro.de/impressum/, trimmed to what §5 DDG requires; the
// plan records what was left out and why.
export const ImpressumPage = () => (
  <Stack spacing={3}>
    <Typography variant="h1">Impressum</Typography>

    <Stack spacing={0.5}>
      <Typography variant="body1">Gemeinsames Rücknahmesystem Servicegesellschaft mbH</Typography>
      <Typography variant="body1">Gotenstraße 14</Typography>
      <Typography variant="body1">20097 Hamburg</Typography>
    </Stack>

    <Stack spacing={0.5}>
      <Typography variant="body1">Telefon: +49 40 23 77 88</Typography>
      <Typography variant="body1">
        E-Mail: <Link href="mailto:info@grs-batterien.de">info@grs-batterien.de</Link>
      </Typography>
    </Stack>

    <Stack spacing={0.5}>
      <Typography variant="body1">Handelsregister Hamburg HRB 133867, Gerichtsstand Hamburg</Typography>
      <Typography variant="body1">USt-IdNr. DE297016104</Typography>
    </Stack>

    <Typography variant="body1">Geschäftsführerin: Anne Sabine Zoller</Typography>
  </Stack>
);
